module.exports = __webpack_public_path__ + "static/media/tauren.518d4522.png";